import { render } from "./AddNewIntegration.vue?vue&type=template&id=4f648c14"
import script from "./AddNewIntegration.vue?vue&type=script&lang=js"
export * from "./AddNewIntegration.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__